module.exports = __webpack_public_path__ + "static/img/botampImage.859c1fc6.png";